<style lang="scss" scoped>
.classes {
	& /deep/ .el-select {
		width: 100%;
	}
	&__container {
		@include container;
	}
	&__panel {
		@include main-panel;
	}
	&__header {
		@include flex-center;
		&__options {
			margin-left: auto;
		}
	}
	&__footer {
		@include main-panel-footer;
		&__right {
			margin-left: auto;
		}
	}
	&__warning {
		color: red;
		font-size: 20px;
		padding-top: 7px;
	}
	&__table {
		td,
		th {
			&:first-child {
				padding-left: 40px;
			}
			&:last-child {
				padding-right: 40px;
			}
		}
		tbody tr{
			cursor: pointer;
		}
		&__missing-item {
			display: inline-block;
			padding-left: 10px;
			color: red;
			font-size: 16px;
			vertical-align: middle;
		}
	}

}

</style>
<template lang="pug">
div
	.classes(v-if="['classrooms', 'teams'].includes(this.$route.name)")
		app-header
			.classes__header(slot="header")
				h1 {{ featureLabel }}s
				.classes__header__options
					el-button(:type="!includeArchivedClasses ? 'primary' : 'danger'", @click="getArchivedClasses(!includeArchivedClasses)",  style="margin-right:15px").ml-auto {{ !includeArchivedClasses ? 'Show archived ' : 'Hide archived ' }} {{ featureLabel.toLowerCase() }}s
					el-button(type="primary", @click="refetchClasses",  style="margin-right:15px").ml-auto Refetch {{ featureLabel.toLowerCase() }}s
		.classes__container
			.classes__panel
				loading(v-if="$apollo.loading || saveLoading || classesLoading")
				template(v-else)
					result-filter.ml-auto.mr-2(v-model="filters", :filter-fields="fields", :remember="true")
					table.table.classes__table
						thead
							tr
								th {{ featureLabel }} Id
								th(width="500") Name
								th(width="150") Status
								th(width="25") Action
						tbody
							tr(v-for='(row, index) in paginated', @click='rowClicked(row)', :key='index')
								td {{row.id}}
								td  {{row.name}}
								td {{row.courseState}}
								td
									el-button(v-if="row.courseState === 'ACTIVE'", type="warning", size="small" @click.stop="archiveClass(row.id)",  style="margin-right:15px").ml-auto Archive

					.classes__footer
						.classes__footer__left
							el-pagination(background="", layout="prev, pager, next", :current-page.sync="page", :page-size="per_page", :total="filtered.length")
						.classes__footer__right 
							| Showing
							strong &nbsp;{{ paginated.length }}
							| &nbsp;out of a possible
							strong &nbsp;{{ filtered.length }}
							| &nbsp;results
	<router-view></router-view>
</template>
<script>
import gql from "graphql-tag";
import _ from "lodash";
import Fuse from "fuse.js";

const ARCHIVE_THIRD_PARTY_CLASS = gql`
	mutation ArchiveThirdPartyClass($classId: String) {
		ArchiveThirdPartyClass(data: { classId: $classId })
	}
`;

export default {
	data() {
		return {
			thirdPartyClasses: [],
			refetchingClasses: false,
			includeArchivedClasses: false,
			filters: null,
			saveLoading: false,
			page: 1,
			per_page: 50,
			optionLimit: 20,
			fields: [
				{
					name: "Name",
					path: "name",
					type: "text",
				},
				{
					name: "Status",
					path: "status",
					type: "radio",
					options: [
						{
							label: "Active",
							value: "active",
						},
						{
							label: "Archived",
							value: "archived",
						},
					],
				},
			],
			
		};
	},

	computed: {
		filtered() {
			let filtered = this.thirdPartyClasses;
			if (this.thirdPartyClasses && this.filters) {
				if (this.filters.name) {
					filtered = _.filter(filtered, (row) => _.startsWith(row.name.toLowerCase(), this.filters.name.toLowerCase()));
				}
				if (this.filters.status) {
					filtered = _.filter(filtered, (row) => {
						return this.filters.status.toLowerCase() === row.courseState.toLowerCase();
					});
				}
			}

			return filtered;
		},
		paginated() {
			let page = _.chunk(this.filtered, this.per_page)[this.page - 1];

			return page ? page : [];
		},

		classesLoading() {
			if(this.refetchingClasses) return true;
			return _.isEmpty(this.thirdPartyClasses);
		},

		featureLabel() {
			return ({
				"gapps": "Classroom",
				"msft": "Team"
			})[this.providerCode];
		}
	},

	methods: {
		rowClicked(row) {
			if (row.courseState === "ACTIVE" || this.providerCode === "gapps") {
				this.$router.push({
					name: "classrooms.select",
					params: {
						id: row.id,
					},
				});
			}		
		},
		async refetchClasses() {
			this.$confirm(
					`Re-fetching classes will take some time. Are you sure you want to proceed?`,
					"Warning",
					{
						confirmButtonText: "OK",
						cancelButtonText: "Cancel",
						type: "warning"
					}
			).then(async () => {
				try {
					await this.$apollo.mutate({
						mutation: gql`
							mutation CacheClear($item: CacheTypeEnum!){
								CacheClear(item: $item)
							}`,
							variables: {
								item: this.includeArchivedClasses ? "classes_archived" : "classes"
							}
					});
					this.thirdPartyClasses = [];
					await this.$apollo.queries.thirdPartyClasses.refetch();
				} catch (e) {
					this.$message.error("Failed to re-fetch classes");
				}
			})
		},
		async archiveClass(classId) {
			// need to archive class in SP and then unmatch class in provision
			this.$confirm(
					"Archiving this class will set it back to Create on sync in the Match classes page. The class will be re-provisioned on the next sync",
					"Warning",
					{
						confirmButtonText: "OK",
						cancelButtonText: "Cancel",
						type: "warning"
					}
			).then(async () => {
				try {
					this.saveLoading = true;
					await this.$apollo.mutate({
						mutation: ARCHIVE_THIRD_PARTY_CLASS,
						variables: {
						classId
					},
					});
					this.$message.success('Successfully archived class. Please wait while classes are re-fetched');
					//go get our classes again now we've archived a class
					await this.clearClassesCache();
					this.saveLoading = false;
				} catch (e) {
					this.$message.error("Failed to archive class");
				}
			})
		},
		async getArchivedClasses(state) {
			await this.refetchClasses();
			this.includeArchivedClasses = state;
		},
		async clearClassesCache() {
			try {
				await this.$apollo.mutate({
					mutation: gql`
						mutation CacheClear($item: CacheTypeEnum!) {
							CacheClear(item: $item)
						}`,
						variables: {
							item: this.includeArchivedClasses ? "classes_archived" : "classes"
						}
				});
				this.refetchingClasses = true;
				this.thirdPartyClasses = [];
				this.thirdPartyClassesFiltered = [];
				await this.$apollo.queries.thirdPartyClasses.refetch();
			} catch (e) {
				this.$message.error("Failed to re-fetch classes");
			}
		}
	},

	apollo: {
		// SP Provider Data
		thirdPartyClasses: {
			query: gql`
				query ThirdPartyClasses($includeArchived: Boolean!) {
					ThirdPartyClasses(includeArchived: $includeArchived) {
						id
						name
						courseState
					}
				}
			`,
			variables() {
				return {
					includeArchived: this.includeArchivedClasses
				}
			},
			fetchPolicy: "no-cache",
			update(r) {
				if (r.ThirdPartyClasses && r.ThirdPartyClasses.length > 0) {
					this.refetchingClasses = false;
				}
				return r.ThirdPartyClasses;
			},
			pollInterval: 5000,
			error(e) {
				this.$message({
					type: "error",
					message: `Something went wrong. Please refresh the page.`,
					duration: 0,
					showClose: true
				});
			},
			skip() {
				return !this.classesLoading;
			}
		}
	}
};
</script>
